import { useEffect, useState } from 'react';

export const useLanguage = () => {
  const [language, setLanguage] = useState(
    localStorage.getItem('language') || 'en'
  );

  useEffect(() => {
    const updateLanguage = () => {
      setLanguage(localStorage.getItem('language') || 'en');
    };

    window.addEventListener('languageChange', updateLanguage);

    return () => {
      window.removeEventListener('languageChange', updateLanguage);
    };
  }, []);

  return language;
};